<div id="content" class="allcp-form" ng-controller="ChecklistTemplateController">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="row mt20">
		<div class="panel">

			<div class="panel-heading">
				<span class="panel-title"> Checklist Şablon Ekle</span>
				<hr>
			</div>
			<div class="panel-body pn">
				<div class="col-md-7">
					<form ng-submit="save()" class="form-horizontal allcp-form">
					
						<div class="form-group">
							<label class="col-md-3 control-label">
								Şablon Adı *
							</label>
							<div class="col-md-9">
								<label for="name21" class="field prepend-icon">
									<input type="text" ng-model="checklistTemplate.name" class="gui-input br-light light" placeholder="Şablon Adı" required>
									<label for="name21" class="field-icon">
										<i class="fa fa-list-alt"></i>
									</label>
								</label>
							</div>
						</div>

						<div class="form-group mt10">
							<div class="row pn mn mb10" ng-repeat="item in checklistTemplate.items">
								<label class="col-md-3 control-label">
								</label>
								<div class="col-md-8">
									<textarea ng-model="item.description"" placeholder="Checklist Detay" class="form-control input-md" cols="30" rows="3"></textarea>
								</div>

								<div class="col-md-1 pr5 pl5">
									<a href="#" ng-click="removeChecklist($index)"><i class="fa fa-times"></i></a>
								</div>
							</div>
						</div>

						<div class="form-group">
							<label class="col-md-3 control-label">
							</label>
							<div class="col-md-9">
								<a href="#" ng-click="addChecklist()">
									<strong> <i class="fa fa-plus"></i> Yeni Checklist Ekle</strong>
								</a>
							</div>
						</div>

						<div class="form-group">
							<div class="col-md-12">
								<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Kaydet</a>
							</div>
						</div>

					</form>
				</div>
			</div>
		</div>
	</div>
</div>
